import { gql } from '@apollo/client';
export const getInviteCategories = gql `
  query GetInviteCategories {
    categories: categories2(orderBy: [{ order: asc }]) {
      id
      metadata {
        id
        title
        marketLocaleCode
      }
    }
  }
`;
